'use client';

import { FC } from 'react';

export interface BlogEmailCaptureProps {
  theme?: 'blue' | 'citron' | 'gray';
  align?: 'left' | 'center';
  placeholder?: string;
  buttonText?: string;
}

const BlogEmailCapture: FC<BlogEmailCaptureProps> = ({ 
  theme, 
  align = 'center',
  placeholder = "Enter your email",
  buttonText = "Subscribe",
}) => {

  const buttonClass = {
    blue: 'button-tertiary-blue-900',
    citron: 'button-primary-citron',
    gray: 'button-tertiary-blue-900',
  }[theme || 'blue'];

  const inputClass = {
    blue: 'bg-white',
    citron: 'bg-white',
    gray: 'bg-gray-100',
  }[theme || 'blue'];

  return (
    <form className={`flex max-sm:flex-wrap justify-${align == 'left' ? 'start' : align} items-stretch gap-1 md:gap-[4px] w-full`}>
      <input
        type="text"
        placeholder={placeholder}
        className={`${inputClass} ${align == 'center' ? 'sm:max-w-[346px]' : ''} max-sm:w-full rounded-circle px-2 py-1 flex-grow placeholder:text-gray-600 text-blue-800 text-caption1`}
        required
      />
      <button className={`${buttonClass} button button-size-medium-blog max-sm:w-full`}>
        {buttonText}
      </button>
    </form>
  );
}

export default BlogEmailCapture;
